var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.id !== _vm.$user.id)?_c('v-btn',_vm._b({attrs:{"loading":_vm.loading},on:{"click":_vm.onClick}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-account-cancel")]),_vm._v(" "+_vm._s(_vm.isBlocked ? _vm.$t("common.unblock") : _vm.$t("common.block"))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }